import classNames from 'classnames';
import { forwardRef, useLayoutEffect, useRef, useState } from 'react';
const scrollRegionCss = "s1x3yogb";
const ScrollRegion = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(scrollRegionCss, props.className)} />;
});
const scrollContainerCss = "scgch0p";

// Match list item vertical padding (spaceSmall); when scroll shadows show, double the
// inset at the scroll edges so content is not visually clipped under the fades.
const scrollContainerScrollableCss = "s1rjqgkx";
const scrollShadowCss = "s18gg5b6";
const topShadowCss = "t1dswps0";
const bottomShadowCss = "b1kh2wvz";
const shadowHiddenCss = "suqv0qr";
const TopShadow = forwardRef((props, ref) => {
  const {
    isVisible,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} aria-hidden {...restProps} data-is-visible={isVisible} className={classNames(scrollShadowCss, topShadowCss, {
    [shadowHiddenCss]: !isVisible
  }, props.className)} />;
});
const BottomShadow = forwardRef((props, ref) => {
  const {
    isVisible,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} aria-hidden {...restProps} data-is-visible={isVisible} className={classNames(scrollShadowCss, bottomShadowCss, {
    [shadowHiddenCss]: !isVisible
  }, props.className)} />;
});
const isScrollable = element => element.scrollHeight - element.clientHeight > 1;
export const AccessListScroll = ({
  children
}) => {
  const scrollRef = useRef(null);
  const [showScrollShadows, setShowScrollShadows] = useState(false);
  useLayoutEffect(() => {
    const element = scrollRef.current;
    if (!element) {
      return undefined;
    }
    const syncScrollShadows = () => {
      setShowScrollShadows(isScrollable(element));
    };
    syncScrollShadows();
    const resizeObserver = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(syncScrollShadows) : null;
    resizeObserver?.observe(element);
    return () => {
      resizeObserver?.disconnect();
    };
  }, []);
  return <ScrollRegion data-testid="access-list-scroll">
      <TopShadow isVisible={showScrollShadows} data-testid="access-list-scroll-shadow-top" />
      <div ref={scrollRef} className={classNames(scrollContainerCss, {
      [scrollContainerScrollableCss]: showScrollShadows
    })} data-testid="access-list-scroll-container" data-scrollable={showScrollShadows}>
        {children}
      </div>
      <BottomShadow isVisible={showScrollShadows} data-testid="access-list-scroll-shadow-bottom" />
    </ScrollRegion>;
};

require("./access_list_scroll.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./access_list_scroll.js");